module.exports = __webpack_public_path__ + "static/media/attachment.82e835e3.png";